import React from "react";
import {ResponsiveContainer, PieChart as PieChartCore, Pie, Cell} from "recharts";
import {pieChartPropType} from "./PieChartPropTypes";
import {PieChartWrapper} from "./pieChartStyles";

export const PieChart = ({data}: pieChartPropType) => {
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        percent,
        index
    }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="white"
                textAnchor={"middle"}
                dominantBaseline="central"
                fontSize={14}
                fontWeight={"bold"}
            >
                {`${data[index].value} `}
            </text>
        );
    };
    return (
        <PieChartWrapper>
            <ResponsiveContainer aspect={1} width={"100%"} height={"100%"}>
                <PieChartCore margin={{top: 0, left: 0, right: 0, bottom: 0}}>
                    <Pie
                        dataKey="value"
                        data={data}
                        labelLine={false}
                        cx="40%"
                        cy="50%"
                        label={renderCustomizedLabel}
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color || "grey"} />
                        ))}
                    </Pie>
                </PieChartCore>
            </ResponsiveContainer>
        </PieChartWrapper>
    );
};
